

import { Plane, CreditCard, Hotel, UtensilsCrossed, Car, Ticket } from 'lucide-react'


const features = [
  {
    title: "Flights",
    icon: Plane,
    description: "Complete flight arrangements for journey"
  },
  {
    title: "Visa Fees",
    icon: CreditCard,
    description: "All visa processing and fees included"
  },
  {
    title: "Hotel Stay ",
    icon: Hotel,
    description: "Comfortable stays with essential facilities"
  },
  {
    title: "Food",
    icon: UtensilsCrossed,
    description: "Customized meal plans as preferences"
  },
  {
    title: "Coach and Driver",
    icon: Car,
    description: "Dedicated transportation services"
  },
  {
    title: "Entrance Fees",
    icon: Ticket,
    description: "Access to all attractions covered"
  }
]

export default function FeaturesGrid() {
  return (
    <div className="bg-white pb-5 ">
      <div className="mx-auto max-w-5xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
        <h1 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-gray-800 text-center mt-5 mb-10 md:mb-14">Inclusions</h1>

          {/* <p className="mt-4 text-lg leading-8 text-gray-600">
            Everything you need for a comfortable and hassle-free journey is included in your package
          </p> */}
        </div>

        <div className="grid grid-cols-1 gap-x-0 gap-y-8 sm:gap-y-10 lg:grid-cols-3">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="mb-6 rounded-lg bg-blue-50 p-4">
                  <Icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold leading-7 text-gray-900">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-gray-600">
                  {feature.description}
                </p>
              </div>
            )
          })}
        </div>
        {/* <div className="mt-16 flex justify-center">
            <Link to='/eligibility'>
          <button
            className="rounded-full bg-blue-600 px-8 py-3 text-base font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            Try It Today
          </button>
          </Link>
        </div> */}
      </div>
    </div>
  )
}

